<template lang="pug">
  .mt-4.mb-8.border.border-gray-200.rounded
    .p-4.rounded-b
      slot
    .bg-gray-900
      .py-2.px-4.text-white {{ lang }}
    pre.language-pug.rounded-t-none.rounded-b(v-if="vue" v-html="highlight(vue, 'pug')")
      slot
    pre.language-html.rounded-t-none.rounded-b(v-else ref="code")
      slot
</template>

<script>
  import Prism from 'prismjs';
  import 'prismjs/components/prism-pug';
  import 'prism-themes/themes/prism-xonokai.css';
  import prettier from 'prettier/standalone';
  import parserHtml from 'prettier/parser-html';

  export default {
    props: {
      vue: {
        type: String,
        default: '',
      },
    },
    computed: {
      lang () {
        return this.vue ? 'VueJS' : 'html';
      },
    },
    mounted () {
      const codeElement = this.$refs.code;
      if ( codeElement ) {
        let code = codeElement.innerHTML;
        if (!this.vue) {
          code = prettier.format(code, {
            parser: 'html',
            plugins: [parserHtml],
          });
        }
        codeElement.innerHTML = this.highlight(code, this.lang);
      }
    },
    methods: {
      highlight (code, lang) {
        return Prism.highlight(code, Prism.languages[lang], lang);
      },
    },
  };
</script>

<style>
  code[class*="language-"], pre[class*="language-"] {
    background: #2d3749;
    color: #fff;
    white-space: pre;
    border: 0;
    border-radius: 0.625rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .token.tag {
    color: #76d9e6;
  }
</style>
